<template>
  <div>
    <el-input
      class="search-el"
      size="mini"
      v-model="query.keyword"
      clearable
      placeholder="请输入名称"
    ></el-input>

    <el-select
      class="search-el"
      size="mini"
      v-model="query.coupon_category"
      placeholder="全部"
      clearable
      filterable
    >
      <el-option label="全部" value=""></el-option>
      <el-option label="普通满减券" value="normal"></el-option>
      <el-option label="折扣券" value="discount"></el-option>
    </el-select>

    <el-select
        class="search-el"
        size="mini"
        v-model="query.type"
        placeholder="使用范围"
        clearable
        filterable
    >
      <el-option label="使用范围" value=""></el-option>
      <el-option label="线上课程通用券" value="22"></el-option>
      <el-option label="365会员" value="1"></el-option>
      <el-option label="普通课程" value="2"></el-option>
      <el-option label="线下课" value="3"></el-option>
      <el-option label="新直播课" value="5"></el-option>
      <el-option label="生活馆" value="7"></el-option>
      <el-option label="有声书" value="10"></el-option>
      <el-option label="兑换券" value="21"></el-option>
      <el-option label="专题课" value="12"></el-option>
      <el-option label="个案咨询" value="16"></el-option>
      <el-option label="体验营" value="23"></el-option>
      <el-option label="心理咨询" value="17"></el-option>
    </el-select>

    <el-select
        class="search-el"
        size="mini"
        v-model="query.status"
        placeholder="优惠券状态"
        clearable
        filterable
    >
      <el-option label="优惠券状态" value=""></el-option>
      <el-option label="正在使用" value="1"></el-option>
      <el-option label="已经过期" value="0"></el-option>
    </el-select>

    <el-select
        class="search-el"
        size="mini"
        v-model="query.approve_status"
        placeholder="审核状态"
        clearable
        filterable
    >
      <el-option label="审核状态" value=""></el-option>
      <el-option label="待审批" value="2"></el-option>
      <el-option label="审批通过" value="3"></el-option>
      <el-option label="无需审批" value="1"></el-option>
      <el-option label="审核不通过" value="4"></el-option>
    </el-select>

    <el-input
        class="search-el"
        size="mini"
        v-model="query.admin_keyword"
        clearable
        placeholder="申请人"
        v-if="achievementsStatus == 1"
    ></el-input>

    <el-button type="primary" size="mini" @click="searchCoupon()"> 查询 </el-button>
    <span style="font-size: 13px; color: #D9001B;margin-left: 10px;">
      <p>注意：如果创建完优惠券，没有设置用户，则此优惠券适配所有用户！</p>
    </span>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0;"
      >
        <el-table-column prop="id" label="ID" align="center" width="60"></el-table-column>
        <el-table-column label="状态" align="center" width="67">
          <template slot-scope="{ row }">
            <div>{{ row.status}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <div>{{ row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="coupon_category" label="类型" align="center" min-width="6%"></el-table-column>
        <el-table-column label="满多少" align="center" min-width="4%">
          <template slot-scope="{ row }">
            <span v-if="row.coupon_category_value == 'normal'">
                <div>{{ row.start }}</div>
            </span>
            <span v-if="row.coupon_category_value == 'discount'">
                <div>-</div>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="减多少" align="center" min-width="4%">
          <template slot-scope="{ row }">
            <span v-if="row.coupon_category_value == 'normal'">
                <div>{{ row.reduce }}</div>
            </span>
            <span v-if="row.coupon_category_value == 'discount'">
                <div>-</div>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="折扣价" align="center" min-width="4%">
          <template slot-scope="{ row }">
            <span v-if="row.coupon_category_value == 'normal'">
                <div>-</div>
            </span>
            <span v-if="row.coupon_category_value == 'discount'">
              <div>{{ row.reduce }}</div>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="开始时间" align="center" min-width="6%">
          <template slot-scope="{ row }">
            <span v-if="row.assert_type == 0">
                {{row.begin_at}}
            </span>
            <span v-if="row.assert_type == 1">
                领取立即生效
            </span>
          </template>
        </el-table-column>
        <el-table-column label="到期时间" align="center" min-width="6%">
          <template slot-scope="{ row }">
            <span v-if="row.assert_type == 0">
                {{row.expire_at}}
            </span>
            <span v-if="row.assert_type == 1">
                领取{{row.assert_days}}天内
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="stock" label="发放量" align="center" min-width="4%"></el-table-column>
        <el-table-column label="领取" align="center" width="70">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" align="center"
                       @click="sid = row.id;relation.chooseOrgVisible = true;couponUserGet();">{{ row.get_user }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="使用" align="center" width="80">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" align="center"
                       @click="sid = row.id;useList.chooseOrgVisible = true;couponUserUse();">{{ row.use_value }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="使用范围" align="center" min-width="5%"></el-table-column>
        <el-table-column label="全部/指定" align="center" width="104">
          <template slot-scope="{ row }">
<!--            <span v-if="row.course_value_type == 2">
              <el-button type="text" size="small" align="center"
                         @click="sid = row.id;productShow.chooseOrgVisible = true;couponProduct();">{{row.course_value }}
              </el-button>
            </span>
            <span v-if="row.course_value_type == 1 || row.course_value_type == 3">{{ row.course_value }}</span>
            <span v-if="row.course_value_type == 4">
              <el-button type="text" size="small" align="center"
                         @click="sid = row.id;couType = row.type_value;courseShow.chooseOrgVisible = true;couponCourses();">{{row.course_value }}
              </el-button>
            </span>-->
            <div>{{ row.course_value }}</div>
          </template>
        </el-table-column>
        <el-table-column label="用户" align="center" width="104">
          <template slot-scope="{ row }">
            <span v-if="row.is_admin_status == 1">
              <span v-if="row.approve_status_value == 1 || row.approve_status_value == 3">
                <span>用户查看</span>
              </span>
              <span v-if="row.approve_status_value == 2 || row.approve_status_value == 4">
                <span>用户设置</span>
              </span>
            </span>
            <span v-if="row.is_admin_status == 0">
              <span v-if="row.super_status == 1">
                <span>用户查看</span>
              </span>
              <span v-if="row.super_status == 0">
                <span>用户设置</span>
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="二维码" align="center" width="75">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" align="center"
                       @click="copyLink.chooseOrgVisible = true;showCode(row.id,row.userCode);" :disabled="row.approve_status_value == 2 || row.approve_status_value == 4">{{ row.qrcode }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" align="center" min-width="6%"></el-table-column>
        <el-table-column prop="real_name" label="申请人" align="center" min-width="6%"></el-table-column>
        <el-table-column label="审核状态" align="center" width="116">
          <template slot-scope="{ row }">
            <span v-if="row.approve_status_value == 2 || row.approve_status_value == 3 || row.approve_status_value == 4">
              <el-button type="text" size="mini" align="center"
                         @click="approveList.chooseOrgVisible = true;getApproveList(row.id);">{{ row.approve_status }}
              </el-button>
            </span>
            <span v-if="row.approve_status_value == 1">{{ row.approve_status }}</span>
          </template>
        </el-table-column>



        <el-table-column label="操作" align="center" min-width="10%">
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="search_query.page"
          :page-size="search_query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>


    <el-dialog
        title="领取列表"
        :visible.sync="relation.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="addRelationEditFormOnClose"
        width="80%"
    >
      <el-form :inline="true" :model="relation.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
              size="small"
              v-model="relation.query.search"
              placeholder="呢称/姓名/电话"
              clearable
          />
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
              v-model="relation.query.begin_at"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择开始时间"
          >
          </el-date-picker>
          ~
          <el-date-picker
              v-model="relation.query.end_at"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
              type="primary"
              size="small"
              @click="
              couponUserGet();
            "
          >
            查询
          </el-button>
          <el-button type="primary" size="small" @click="userGetExportData()">导出</el-button>
        </el-form-item>
      </el-form>
      <!--列表-->
      <el-table
          border
          :data="relation.result.data"
          highlight-current-row
          v-loading="relation.listLoading1"
          style="..."
      >
        <el-table-column prop="id" label="ID" align="center" width="80"></el-table-column>
        <el-table-column prop="user_id" label="USER_ID" align="center" width="90"></el-table-column>
        <el-table-column prop="nickname" label="呢称" align="center"></el-table-column>
        <el-table-column prop="mobile_phone" label="手机号码" align="center"></el-table-column>
        <el-table-column prop="is_use_value" label="使用" align="center"></el-table-column>
        <el-table-column prop="get_type" label="类型" align="center"></el-table-column>
        <el-table-column prop="created_at" label="领取时间" align="center"></el-table-column>
        <el-table-column prop="updated_at" label="使用时间" align="center"></el-table-column>
        <el-table-column prop="order_no" label="订单号" align="center"></el-table-column>

        <el-table-column label="操作" align="center" width="165">
          <template slot-scope="{ row }">
            <span v-if="row.is_use == 0">
              <el-button type="primary" size="mini" @click="setIsUse(row)">
                设置使用
              </el-button>
            </span>
            <span v-if="row.is_use == 1">
              已使用
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          @current-change="couponUserGet"
          :current-page.sync="relation.query.page"
          :page-size="relation.query.limit"
          layout="total, prev, pager, next, jumper"
          :total="relation.result.total"
      >
      </el-pagination>
    </el-dialog>

    <el-dialog
        title="使用列表"
        :visible.sync="useList.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="couponUserUseFormOnClose"
        width="80%"
    >
      <el-form :inline="true" :model="useList.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
              size="small"
              v-model="useList.query.search"
              placeholder="呢称/姓名/电话"
              clearable
          />
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
              v-model="useList.query.begin_at"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择开始时间"
          >
          </el-date-picker>
          ~
          <el-date-picker
              v-model="useList.query.end_at"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
              type="primary"
              size="small"
              @click="
              couponUserUse();
            "
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <!--列表-->
      <el-table
          border
          :data="useList.result.data"
          highlight-current-row
          v-loading="useList.listLoading1"
          style="..."
      >
        <el-table-column prop="id" label="ID" align="center" width="80"></el-table-column>
        <el-table-column prop="user_id" label="USER_ID" align="center" width="90"></el-table-column>
        <el-table-column prop="nickname" label="呢称" align="center"></el-table-column>
        <el-table-column prop="mobile_phone" label="手机号码" align="center"></el-table-column>
        <el-table-column prop="is_use_value" label="使用" align="center"></el-table-column>
        <el-table-column prop="get_type" label="类型" align="center"></el-table-column>
        <el-table-column prop="created_at" label="领取时间" align="center"></el-table-column>
        <el-table-column prop="updated_at" label="使用时间" align="center"></el-table-column>
        <el-table-column prop="order_no" label="订单号" align="center"></el-table-column>
        <el-table-column
            prop="body"
            label="已购课程名称"
            align="center">
        </el-table-column>

        <el-table-column label="操作" align="center" width="165">
          <template slot-scope="{ row }">
            <span v-if="row.is_use == 0">
              <el-button type="primary" size="mini" @click="setIsUse(row)">
                设置使用
              </el-button>
            </span>
            <span v-if="row.is_use == 1">
              已使用
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          @current-change="couponUserUse"
          :current-page.sync="useList.query.page"
          :page-size="useList.query.limit"
          layout="total, prev, pager, next, jumper"
          :total="useList.result.total"
      >
      </el-pagination>
    </el-dialog>

    <el-dialog
        title="列表"
        :visible.sync="courseShow.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="couponCoursesFormOnClose"
        width="80%"
    >
      <!--列表-->
      <el-table
          border
          :data="courseShow.result.data"
          highlight-current-row
          v-loading="courseShow.listLoading1"
          style="..."
      >
        <el-table-column prop="id" label="ID" align="center" min-width="15%"></el-table-column>
        <el-table-column prop="title" label="名称" align="center"></el-table-column>
        <el-table-column prop="price" label="价格" align="center" min-width="25%"></el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
        title="指定商品列表"
        :visible.sync="productShow.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="couponProductFormOnClose"
        width="80%"
    >
      <!--列表-->
      <el-table
          border
          :data="productShow.result.data"
          highlight-current-row
          v-loading="productShow.listLoading1"
          style="..."
      >
        <el-table-column prop="id" label="商品ID" align="center" min-width="10%"></el-table-column>
        <el-table-column prop="title" label="商品名称" align="center" min-width="40%"></el-table-column>
        <el-table-column prop="price" label="商品原价" align="center" min-width="30%"></el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
        title="指定列表"
        :visible.sync="targetRange.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="targetRangeClose"
        width="80%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-button
              type="primary"
              size="small"
              @click="addTargetDialog();">
            添加
          </el-button>
        </el-form-item>
      </el-form>
      <el-table
          border
          :data="targetRange.result.data"
          highlight-current-row
          v-loading="targetRange.listLoading1"
          style="..."
      >
        <el-table-column prop="id" label="ID" align="center" min-width="15%"></el-table-column>
        <el-table-column prop="title" label="名称" align="center"></el-table-column>
        <el-table-column prop="price" label="价格" align="center" min-width="25%"></el-table-column>
        <el-table-column label="操作" align="center" min-width="14%">
          <template slot-scope="{row} ">
            <el-button  v-if="row.lineNum>1" type="danger" size="small" @click="delTarget(targetRange.coupon_id,row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
        title="复制链接"
        :visible.sync="copyLink.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="copyLinkFormOnClose"
        width="850px"
    >
      <div class="modal-content">
        <div class="modal-body text-center">
          <el-input size="small" v-model="copyLink.link" clearable style="width: 720px;"/>
          <el-button type="primary" size="mini" @click="copy()" style="position: absolute;left: 88%;">复制</el-button>
          <div id="qrcode" style="margin-left: 256 /2; position: relative; left: 35%;top:16px;"></div>
          <span style="left: 35%;top: 24px;position: relative;">
            鼠标右键“图片另存为”即可下载二维码
          </span>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="优惠券审核" :visible.sync="approve.chooseOrgVisible" width="35%">
      <el-form :model="approve.query">
        <el-form-item v-if="approve.reason" label="申请理由：">
          <span>{{ approve.reason }}</span>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="approve.query.action">
            <el-radio :label="1">同意</el-radio>
            <el-radio :label="0">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核理由">
          <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="approve.query.reason">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="approve.chooseOrgVisible = false">取 消</el-button>
        <el-button type="primary" @click="approve.chooseOrgVisible = false; addApprove()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
        title="审核详情"
        :visible.sync="approveList.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="approveListFormOnClose"
        width="70%"
    >
      <!--列表-->
      <el-table
          border
          :data="approveList.result.data"
          highlight-current-row
          v-loading="approveList.listLoading1"
          style="..."
      >
        <el-table-column prop="admin_id" label="审核人" align="center" min-width="10%"></el-table-column>
        <el-table-column prop="action" label="审核结果" align="center" min-width="15%"></el-table-column>
        <el-table-column prop="reason" label="审核理由" align="center" min-width="30%"></el-table-column>
        <el-table-column prop="created_at" label="审核时间" align="center" min-width="15%"></el-table-column>
      </el-table>
    </el-dialog>


    <!-- 商品或课程列表 -->
    <el-dialog
        title="选择商品"
        :visible.sync="search.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="addEditFormOnClose"
        width="75%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
              size="small"
              v-model="search.query.search"
              placeholder="请输入标题或ID"
              clearable
              @blur="searchData()"
          />
        </el-form-item>
        <el-form-item>
          <el-button
              type="primary"
              size="small"
              @click="
              searchData();
            "
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table
          border
          ref="multipleTable"
          :data="search.result.data"
          highlight-current-row
          v-loading="search.listLoading1"
          style="..."
          @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
            prop="title"
            label="标题"
            align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt="" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          @current-change="searchData"
          :current-page.sync="search.query.page"
          :page-size="search.query.limit"
          layout="total, prev, pager, next, jumper"
          :total="search.result.total"
      >
      </el-pagination>
      <div style="margin-top: 20px">
        <el-button @click="couponAddTarget()"
        >确定</el-button
        >
        <!--        <el-button @click="toggleSelection()">取消选择</el-button>-->
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  couponSet,
  couponUserGetData,
  setIsUse,
  deleteCoupon,
  couponCourseData,
  couponProductData,
  approveCoupon,
  approveList
} from "@/api/coupon";
import { qrCode, couponGetUrl, copyData } from "@/api/common";
import axios from "axios";
import {
  couponCourseScreen,
  addRelationCourses,
  delRelationCourse,
  getApproveStatus,
  getCanViewCouponList
} from "../../api/coupon";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      achievementsStatus: 0,
      query: {
        keyword: "",
        coupon_category: "",
        type: "",
        status: "",
        approve_status: '',
        admin_keyword:'',
        page: 1,
        limit: 20,
      },
      search_query: {
        keyword: "",
        coupon_category: "",
        type: "",
        status: "",
        approve_status: '',
        admin_keyword:'',
        page: 1,
        limit: 20,
      },
      //添加关联数据搜索参数
      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          type: "",
          page: 1,
          limit: 5,
          id: 0,
          search: "",
        },
        result: {
          total: 0,
          data: [],
        },
      },
      addTarget: {
        id: 0,
        targetIds: []
      },

      sid: 0,
      couType: 0,
      is_delete: 0,

      relation: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          page: 1,
          search: '',
          type: 0,
          coupon_id: 0,
          begin_at: '',
          end_at: '',
          export: 0,
          limit: 10,
        },
        result: {
          total: 0,
          data: [],
        },
      },

      useList: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          page: 1,
          search: '',
          type: 1,
          coupon_id: 0,
          begin_at: '',
          end_at: '',
          limit: 10,
        },
        result: {
          total: 0,
          data: [],
        },
      },

      courseShow: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          coupon_id: 0,
          course_type: 0,
        },
        result: {
          data: [],
        },
      },

      productShow: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          coupon_id: 0,
        },
        result: {
          data: [],
        },
      },

      targetRange: {
        coupon_id: 0,
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          coupon_id: 0,
          course_type: 0,
        },
        result: {
          data: [],
        },
      },
      //获取后台用户列表数据
      getAccountList: {
        submitAccountVisible: false,
        chooseOrgVisible: false,
        listLoading: false,
        query: {
          coupon_id:0
        },
        result: {
          data: [],
        },
      },

      approveList: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          id: 0,
        },
        result: {
          data: [],
        },
      },

      copyLink: {
        chooseOrgVisible: false,
        link:''
      },

      approve: {
        reason: '',
        chooseOrgVisible: false,
        formLabelWidth: '120px',
        query: {
          action: 1, //状态，agree-同意，refuse-拒绝
          reason: '',
          id: 0
        },
      },

      add_relation: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          search: "",
          page: 1,
          limit: 5,
          order_xiao_target_id: 0,
          type: 1
        },
        result: {
          total: 0,
          data: [],
        },
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    toCreate(id, copy_type) {
      this.$router.push({
        path: "/coupon/couponAdd",
        query: {
          id: id,
          copy_type: copy_type,
          category: this.$route.query.category,
          admin_id: this.$route.query.admin_id,
        }
      });
    },

    // 弹窗关闭
    addRelationEditFormOnClose() {
      this.relation.query.page = 1;
      this.relation.result = {
        total: 0,
        data: [],
      };
      this.relation.chooseOrgVisible = false;
      //this.getList()
    },

    couponUserGet(){
      this.relation.query.coupon_id = this.sid;
      this.relation.listLoading1 = true;
      couponUserGetData(this.relation.query).then((response) => {
        this.relation.result.data = response.data.list;
        this.relation.result.total = response.data.total;
        this.relation.listLoading1 = false;
      });
    },

    userGetExportData(){
      let option = {
        search: this.relation.query.search,
        type: this.relation.query.type,
        coupon_id: this.relation.query.coupon_id,
        begin_at:this.relation.query.begin_at,
        end_at:this.relation.query.end_at
      }
      let url = 'https://backend.zhangdefenspace.com/backend/coupon/exportList?';
      if (this.relation.query.search != '') {
        url += `search=${this.relation.query.search}&`;
      }
      if (this.relation.query.type != 0) {
        url += `type=${this.relation.query.type}&`;
      }
      if (this.relation.query.coupon_id != 0) {
        url += `coupon_id=${this.relation.query.coupon_id}&`;
      }
      if (this.relation.query.begin_at != '') {
        url += `begin_at=${this.relation.query.begin_at}&`;
      }
      if(this.relation.query.end_at != ''){
        url += `end_at=${this.relation.query.end_at}`;
      }

      // 移除最后一个字符（可能是 '&'）
      // url = url.slice(0, -1);

      // 跳转
      location.href = url;
      console.log(url,'url');
    },

    // 弹窗关闭
    couponUserUseFormOnClose() {
      this.useList.query.page = 1;
      this.useList.result = {
        total: 0,
        data: [],
      };
      this.useList.chooseOrgVisible = false;
      //this.getList()
    },
    couponUserUse(){
      this.useList.query.coupon_id = this.sid;
      this.useList.listLoading1 = true;
      couponUserGetData(this.useList.query).then((response) => {
        this.useList.result.data = response.data.list;
        this.useList.result.total = response.data.total;
        this.useList.listLoading1 = false;
      });
    },

    // 弹窗关闭
    couponCoursesFormOnClose() {
      this.courseShow.result = {
        data: [],
      };
      this.courseShow.chooseOrgVisible = false;
      this.getList()
    },
    couponCourses(){
      this.courseShow.query.coupon_id = this.sid;
      this.courseShow.query.course_type = this.couType;
      this.courseShow.listLoading1 = true;
      couponCourseData(this.courseShow.query).then((response) => {
        this.courseShow.result.data = response.data;
        this.courseShow.listLoading1 = false;
      });
    },

    //获取关联对象的列表
    targetRangeData(){
      this.targetRange.query.coupon_id = this.targetRange.coupon_id;
      this.targetRange.query.course_type = this.couType;
      this.targetRange.listLoading1 = true;
      couponCourseData(this.targetRange.query).then((response) => {
        this.targetRange.result.data = response.data;
        this.targetRange.result.data.forEach(function (value,key){
          value.lineNum = key+1;
        })
        this.targetRange.listLoading1 = false;
      });
    },
    delTarget(coupon_id,id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delRelationCourse({
          type: this.couType,
          coupon_id: coupon_id,
          target_id: id
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.targetRangeData();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },

    // 弹窗关闭
    couponProductFormOnClose() {
      this.productShow.result = {
        data: [],
      };
      this.productShow.chooseOrgVisible = false;
      this.getList()
    },
    couponProduct(){
      this.productShow.query.coupon_id = this.sid;
      this.productShow.listLoading1 = true;
      couponProductData(this.productShow.query).then((response) => {
        this.productShow.result.data = response.data;
        this.productShow.listLoading1 = false;
      });
    },

    // 弹窗关闭
    approveListFormOnClose() {
      this.approveList.result = {
        data: [],
      };
      this.approveList.chooseOrgVisible = false;
      this.getList()
    },
    getApproveList(id){
      this.approveList.query.id = id;
      this.approveList.listLoading1 = true;
      approveList(this.approveList.query).then((response) => {
        this.approveList.result.data = response.data;
        this.approveList.listLoading1 = false;
      });
    },

    // 弹窗关闭
    copyLinkFormOnClose() {
      this.copyLink.chooseOrgVisible = false;
    },

    showCode(id, userCode) {
      this.copyLink.link = couponGetUrl(id, userCode);
      this.$nextTick(function () {
        document.getElementById("qrcode").innerHTML = "";
        let qrcode = qrCode(couponGetUrl(id, userCode),200,200);
      });
    },

    copy() {
      copyData(this.copyLink.link)
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },


    operateUser(id,val) {
      this.$router.push({
        path: "/coupon/setGroup",
        query: {
          id: id,
          type_value: val
        }
      });
    },

    couponSet(id, type) {
      const text = {0: '下架', 1: '上架'};
      this.$confirm('是否确认【' + text[type] + '】？', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        couponSet({
          id: id,
          status: type,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "设置成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },

    deleteCoupon(row) {
      this.is_delete = 1
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteCoupon({
          id: row.id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },

    addTargetDialog() {
      this.addTarget.targetIds = [];
      this.search.chooseOrgVisible = true;
      this.searchData();
    },
    targetRangeClose(){
      this.targetRange.chooseOrgVisible = false;
      this.addTarget.id = 0;
    },
    // 查询方法
    searchData() {
      this.search.listLoading1 = true;
      this.search.query.type = this.couType;
      couponCourseScreen(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },
    couponAddTarget() {
      let data = {'coupon_id':this.addTarget.id,'target_ids':this.addTarget.targetIds,'type':this.couType}
      getApproveStatus(data).then((response) => {
        if(response.data == 2){
          this.$confirm("申请超过限制，需进行审批", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            addRelationCourses(data)
                .then((response) => {
                  this.updateLoading = false;
                  if (response.status == 2000) {
                    this.$message.success(response.message);
                    this.addEditFormOnClose();
                    this.targetRangeData()
                    this.getList();
                  }
                })
                .catch((err) => {
                  this.updateLoading = false;
                });
          }).catch(() => {
            this.updateLoading = false;
          });
        }else{
          addRelationCourses(data)
              .then((response) => {
                this.updateLoading = false;
                if (response.status == 2000) {
                  this.$message.success(response.message);
                  this.addEditFormOnClose();
                  this.targetRangeData()
                  this.getList();
                }
              })
              .catch((err) => {
                this.updateLoading = false;
              });
        }
      });
      /*addRelationCourses(data)
          .then((response) => {
            this.updateLoading = false;
            if (response.status == 2000) {
              this.$message.success(response.message);
              this.addEditFormOnClose();
              this.targetRangeData()
              this.getList();
            }
          })
          .catch((err) => {
            this.updateLoading = false;
          });*/
    },

    handleSelectionChange(rows) {
      this.addTarget.targetIds = [];
      rows.forEach(row => {
        this.addTarget.targetIds.push(row.id);
      });
      console.log(this.addTarget)
    },

    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.query.search = "";
      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;
      this.addTarget.targetIds = [];
    },

    //审核
    isApprove(id) {
      this.approve.query.id = id;
      this.approve.query.reason = '';
      this.approve.query.action = 1;
    },

    addApprove() {
      var action_value =  this.approve.query.action;
      if (action_value == 1) {
        this.approve.query.action = 'agree'
      } else {
        this.approve.query.action = 'refuse'
      }
      console.log(this.approve.query)
      this.$confirm("确定要提交审核结果?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        approveCoupon(this.approve.query).then((response) => {
          if (response.status == 2000) {
            this.$message({
              showClose: true,
              message: "设置成功",
              type: "success",
            });
            this.approveFormOnClose();
          } else {
            this.approveFormOnClose();
          }
        });
      }).catch(() => {
      });
    },

    // 弹窗关闭
    approveFormOnClose() {
      this.approve.chooseOrgVisible = false;
      this.approve.query.action = 1;
      this.approve.query.reason = '';
      this.approve.query.id = 0;
      this.getList()
    },

    setIsUse(row) {
      this.$confirm("此操作将设置使用, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        setIsUse({
          id: row.id,
        }).then((response) => {
          if (response.status == 2000) {
            this.couponUserGet();
            this.$message({
              showClose: true,
              message: "设置成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },

    searchCoupon() {
      this.query.page = 1
      this.search_query.keyword = this.query.keyword
      this.search_query.coupon_category = this.query.coupon_category
      this.search_query.type = this.query.type
      this.search_query.status = this.query.status
      this.search_query.approve_status = this.query.approve_status
      this.search_query.admin_keyword = this.query.admin_keyword
      this.search_query.page = this.query.page
      this.search_query.limit = this.query.limit
      this.getList()
    },
    getList() {
      this.achievementsStatus = 0
      if (this.is_delete == 1) {
        this.search_query.page = 1
      }
      this.loading = true;
      getCanViewCouponList(this.search_query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.achievementsStatus = response.data.achievementsStatus;
        this.loading = false;
        this.is_delete = 0
      });
    },
  },
  mounted() {},
};
</script>
